import React, { useState } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { IconButton } from "@mui/material";

import { A, Block, H3, Caret } from "commons";
import { format, FORMAT } from "commons/src/NuDateUtils";

export function NewsItem({ title, date, content, links = [] }) {
    const [isExpanded, setIsExpanded] = useState(true);

    const lineBreakToBr = content =>
        content.split("\n").map((item, idx) => (
            <span key={idx}>
                {item}
                <br />
            </span>
        ));

    return (
        <StyledBlock>
            <H3>{title}</H3>
            <p>Added {format(date, FORMAT.SLASH_SEPARATED)}</p>

            {isExpanded ? (
                <>
                    <p>{lineBreakToBr(content)}</p>
                    {links.length > 0 && (
                        <p>
                            <A href={links[0].href} target="_blank" rel="noreferrer noopener">
                                {links[0].rel}
                            </A>
                        </p>
                    )}
                </>
            ) : null}

            <ToggleContainer>
                <IconButton
                    color="secondary"
                    onClick={() => setIsExpanded(v => !v)}
                    data-testid="expand-collapse-news-button"
                    aria-label="expand or collapse this item"
                    size="large"
                >
                    <Caret direction={isExpanded ? "up" : "down"} fontSize="large" />
                </IconButton>
            </ToggleContainer>
        </StyledBlock>
    );
}

const StyledBlock = styled(Block)`
    padding-bottom: 0;
`;

export const ToggleContainer = styled.div`
    display: flex;
    justify-content: center;
`;

NewsItem.propTypes = {
    title: PropTypes.string,
    date: PropTypes.string,
    content: PropTypes.string,
    links: PropTypes.arrayOf(
        PropTypes.shape({
            rel: PropTypes.string,
            href: PropTypes.string
        })
    )
};
